/**
 * Parses section IDs array from a Dédalo `related` JSON string. Example: "[\"navarra500_5\", \"navarra500_8\"]" → [5, 8]
 */
export function parseRelatedSectionIds(related) {
    if (!related) return [];
    const refs = JSON.parse(related);
    if (!Array.isArray(refs)) return [];
    return refs.map((ref) => parseInt(ref.split('_')[1], 10)).filter((id) => !isNaN(id));
}

export function parseJsonArray(raw) {
    try {
        const parsed = JSON.parse(raw ?? '[]');
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
}
